/*--------------
V 0.0.1 - Criado por Larner Diogo

DESCRICAO:
Serviço de Guarda de Rotas


COMPONENTS
***********************************************************/
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Rx';

/**********************************************************
PROVIDERS
***********************************************************/
import { SessionService } from './session';

@Injectable()
export class GuardService implements CanActivate {

  constructor(
    private _SessionService: SessionService,
    private _Router: Router
  ) { }

  /************
  GUARDA DE ROTAS
  *************/
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean{

    if(this._SessionService.getIsLogged()){
        return true
    }else{
        this._Router.navigate(['/no-auth/login']);
        return false;
    }

  }

}


// WEBPACK FOOTER //
// ./src/app/globals/guard.ts